import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-414c392d"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 2,
  class: "accordion-item__info-button"
}
const _hoisted_2 = ["value"]
const _hoisted_3 = ["value"]
const _hoisted_4 = ["value"]
const _hoisted_5 = ["value"]
const _hoisted_6 = ["value"]

import { computed, onMounted, ref, Ref, watch } from 'vue';
import { useStore } from 'vuex';
import { loadFont } from './functions/makerjs';
import AccordionContainer from '@/components/accordion/AccordionContainer.vue';
import AccordionItem from '@/components/accordion/AccordionItem.vue';
import MountingShapePreview from '@/components/MountingShapePreview.vue';
import ShapeSelector from '@/components/ShapeSelector.vue';
import ShapeSettings from '@/components/ShapeSettings.vue';
import MetaInformation from '@/components/MetaInformation.vue';
import DrillHoles from '@/components/DrillHoles.vue';
import CutoutsConfiguration from '@/components/CutoutsConfiguration.vue';
import ShapeUpload from '@/components/ShapeUpload.vue';
import SideSelection from '@/components/SideSelection.vue';
import EdgeFinish from '@/components/EdgeFinish.vue';
import ThicknessSelector from '@/components/ThicknessSelector.vue';
import MaterialSelector from '@/components/MaterialSelector.vue';
import HeaderPricingInformation from '@/components/HeaderPricingInformation.vue';
import MeasurementsHeightTransition from '@/components/UI/MeasurementsHeightTransition.vue';
import InstructionsButton from '@/components/UI/InfoModal/InstructionsButton.vue';
import InfoModal from '@/components/UI/InfoModal/InfoModal.vue';
import { StepTypes } from '@/types/step';

const selectedUnit = 'cm';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const store = useStore();
const i18n = window.measurementSelectorVariables.i18n;
const html = window.measurementSelectorVariables.html;
const shop = window.measurementSelectorVariables.shop;
const settings = window.measurementSelectorVariables.settings;
const measuringInstructions = window.measuringInstructions;
const containerRef = ref<HTMLElement | null>(null);

const shape = computed(() => store.getters.shape);
const isMediaMobileSize = computed(() => store.getters.isMediaMobileSize);
const primitives = computed(() => store.getters.primitives);
const currentStepName = computed(() => store.getters.currentStepName);
const isDrillHolesVisible = computed(() => store.getters.isDrillHolesVisible);
const drillHoleEdgeType = computed(() => store.getters.drillHoleEdgeType);
const alternateThicknesses = computed(() => store.getters.alternateThicknesses);
const measurements = computed(() => store.getters.measurements);
const stringifiedConfig = computed(() => store.getters.stringifiedConfig);
const exportCompositeDxf = computed(() => store.getters.exportCompositeDxf);
const dxfExport = computed(() => store.getters.dxfExport);
const exportShape = computed(() => store.getters.exportShape);
const isShapeComplete = computed(() => store.getters.isShapeComplete);
const isEdgeFinishVisible = computed(() => store.getters.isEdgeFinishVisible);
const isCutoutsVisible = computed(() => store.getters.isCutoutsVisible);
const alternateMaterials = computed(() => store.getters.alternateMaterials);
const showSideSelection = computed(() => store.getters.showSideSelection);

function isPortalActive( stepName: StepTypes ): boolean {
	return currentStepName.value === stepName;
}

function scrollTo(view: Ref<HTMLElement | null>) {
	view.value?.scrollIntoView({ behavior: 'smooth' });
}

onMounted(async () => {

	// Pre-load default font
	const defaultFont = `${window.measurementSelectorVariables.fontDirUrl}Exo-Bold.ttf`;
	const fontObj = await loadFont(defaultFont);

	store.commit('addFont', { fontName: 'Exo-Bold', font: fontObj });
	store.commit('setSelectedFontObject', fontObj );

	window?.dataLayer?.push( {
		event: 'measurements_selector',
		eventCategory: 'Measurements Selector',
		eventAction: 'Display',
		eventLabel: document.title,
	} );
});

watch(currentStepName, async (newValue: StepTypes, oldValue: StepTypes) => {
	if (newValue !== oldValue) {
		if (!isMediaMobileSize.value) {
			scrollTo(containerRef);
		}
	}
});


return (_ctx: any,_cache: any) => {
  const _component_portal = _resolveComponent("portal")!
  const _component_portal_target = _resolveComponent("portal-target")!

  return (_openBlock(), _createElementBlock("div", {
    id: "app-measurements-selector",
    class: "measurements-selector",
    ref_key: "containerRef",
    ref: containerRef
  }, [
    _createVNode(HeaderPricingInformation),
    _createVNode(AccordionContainer, null, {
      default: _withCtx(() => [
        _createVNode(AccordionItem, {
          "step-name": _unref(StepTypes).shapeSize
        }, {
          default: _withCtx(() => [
            _createVNode(ShapeSelector),
            _createVNode(_component_portal, {
              to: "mobile-accordion-preview",
              disabled: !isMediaMobileSize.value
            }, {
              default: _withCtx(() => [
                _createVNode(MountingShapePreview, {
                  primitives: primitives.value,
                  unit: selectedUnit
                }, null, 8, ["primitives"])
              ]),
              _: 1
            }, 8, ["disabled"]),
            (isMediaMobileSize.value && isPortalActive( _unref(StepTypes).shapeSize ))
              ? (_openBlock(), _createBlock(_component_portal_target, {
                  key: 0,
                  name: "mobile-accordion-preview"
                }))
              : _createCommentVNode("", true),
            (shape.value !== 'dxf')
              ? (_openBlock(), _createBlock(ShapeSettings, { key: 1 }))
              : _createCommentVNode("", true),
            _createVNode(MeasurementsHeightTransition, {
              appear: "",
              mode: "out-in"
            }, {
              default: _withCtx(() => [
                (shape.value === 'dxf')
                  ? (_openBlock(), _createBlock(ShapeUpload, { key: 0 }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            (_unref(measuringInstructions) && _unref(measuringInstructions).length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                  _createVNode(InstructionsButton, {
                    "modal-name": "measuringInstrictions",
                    label: _unref(i18n).measuringInstructionsLabel
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(i18n).measuringInstructionsLabel), 1)
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(InfoModal, {
                    "modal-name": "measuringInstrictions",
                    content: _unref(measuringInstructions)
                  }, null, 8, ["content"])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["step-name"]),
        (shape.value !== '' && alternateThicknesses.value.length > 0)
          ? (_openBlock(), _createBlock(AccordionItem, {
              key: 0,
              "step-name": _unref(StepTypes).thickness
            }, {
              default: _withCtx(() => [
                (isMediaMobileSize.value && isPortalActive( _unref(StepTypes).thickness ))
                  ? (_openBlock(), _createBlock(_component_portal_target, {
                      key: 0,
                      name: "mobile-accordion-preview"
                    }))
                  : _createCommentVNode("", true),
                _createVNode(ThicknessSelector)
              ]),
              _: 1
            }, 8, ["step-name"]))
          : _createCommentVNode("", true),
        (shape.value !== '' && alternateMaterials.value.length > 0)
          ? (_openBlock(), _createBlock(AccordionItem, {
              key: 1,
              "step-name": _unref(StepTypes).material
            }, {
              default: _withCtx(() => [
                (isMediaMobileSize.value && isPortalActive( _unref(StepTypes).material ))
                  ? (_openBlock(), _createBlock(_component_portal_target, {
                      key: 0,
                      name: "mobile-accordion-preview"
                    }))
                  : _createCommentVNode("", true),
                _createVNode(MaterialSelector)
              ]),
              _: 1
            }, 8, ["step-name"]))
          : _createCommentVNode("", true),
        (isDrillHolesVisible.value)
          ? (_openBlock(), _createBlock(AccordionItem, {
              key: 2,
              "step-name": _unref(StepTypes).drillholes
            }, {
              default: _withCtx(() => [
                (isMediaMobileSize.value && isPortalActive( _unref(StepTypes).drillholes ) && drillHoleEdgeType.value !== 'around')
                  ? (_openBlock(), _createBlock(_component_portal_target, {
                      key: 0,
                      name: "mobile-accordion-preview"
                    }))
                  : _createCommentVNode("", true),
                _createVNode(DrillHoles)
              ]),
              _: 1
            }, 8, ["step-name"]))
          : _createCommentVNode("", true),
        (isCutoutsVisible.value)
          ? (_openBlock(), _createBlock(AccordionItem, {
              key: 3,
              "step-name": _unref(StepTypes).cutouts
            }, {
              default: _withCtx(() => [
                (isMediaMobileSize.value && isPortalActive( _unref(StepTypes).cutouts ))
                  ? (_openBlock(), _createBlock(_component_portal_target, {
                      key: 0,
                      name: "mobile-accordion-preview"
                    }))
                  : _createCommentVNode("", true),
                _createVNode(CutoutsConfiguration)
              ]),
              _: 1
            }, 8, ["step-name"]))
          : _createCommentVNode("", true),
        (showSideSelection.value)
          ? (_openBlock(), _createBlock(AccordionItem, {
              key: 4,
              "step-name": _unref(StepTypes).sideSelection
            }, {
              default: _withCtx(() => [
                (isMediaMobileSize.value && isPortalActive( _unref(StepTypes).sideSelection ))
                  ? (_openBlock(), _createBlock(_component_portal_target, {
                      key: 0,
                      name: "mobile-accordion-preview"
                    }))
                  : _createCommentVNode("", true),
                _createVNode(SideSelection)
              ]),
              _: 1
            }, 8, ["step-name"]))
          : _createCommentVNode("", true),
        (isEdgeFinishVisible.value)
          ? (_openBlock(), _createBlock(AccordionItem, {
              key: 5,
              "step-name": _unref(StepTypes).edgeFinish
            }, {
              default: _withCtx(() => [
                (isMediaMobileSize.value && isPortalActive( _unref(StepTypes).edgeFinish ))
                  ? (_openBlock(), _createBlock(_component_portal_target, {
                      key: 0,
                      name: "mobile-accordion-preview"
                    }))
                  : _createCommentVNode("", true),
                _createVNode(EdgeFinish)
              ]),
              _: 1
            }, 8, ["step-name"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(MetaInformation, {
      isShapeComplete: isShapeComplete.value,
      availability: _unref(html).availability,
      shape: measurements.value.shape,
      primitives: primitives.value,
      settings: _unref(settings),
      currency: _unref(shop).currency,
      locale: _unref(shop).locale,
      dxfDefinition: measurements.value.dxfDefinition
    }, null, 8, ["isShapeComplete", "availability", "shape", "primitives", "settings", "currency", "locale", "dxfDefinition"]),
    (measurements.value.modifiers.font !== '')
      ? (_openBlock(), _createElementBlock("input", {
          key: 0,
          type: "hidden",
          name: "measurements[modifiers][font]",
          value: measurements.value.modifiers.font
        }, null, 8, _hoisted_2))
      : _createCommentVNode("", true),
    _createElementVNode("input", {
      type: "hidden",
      name: "measurements[shape]",
      value: measurements.value.shape
    }, null, 8, _hoisted_3),
    _createElementVNode("input", {
      type: "hidden",
      name: "measurements[export_shape]",
      value: exportShape.value
    }, null, 8, _hoisted_4),
    (exportCompositeDxf.value)
      ? (_openBlock(), _createElementBlock("input", {
          key: 1,
          type: "hidden",
          name: "measurements[dxf_export]",
          value: dxfExport.value
        }, null, 8, _hoisted_5))
      : _createCommentVNode("", true),
    _createElementVNode("input", {
      type: "hidden",
      name: "measurements_config",
      value: stringifiedConfig.value
    }, null, 8, _hoisted_6)
  ], 512))
}
}

})